export default __webpack_public_path__ + "static/cars-0213786b3c75c15494fce6299aaf28e2.mp4";